import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Parse a numeric string and clamp to [min, max] range. Returns null for non-numeric input. */
export function parseNumber(raw: string, min?: number, max?: number): number | null {
  if (raw === '' || raw === '-') return null;
  const num = parseFloat(raw);
  if (isNaN(num)) return null;
  return Math.min(Math.max(num, min ?? -Infinity), max ?? Infinity);
}
